// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
import { DirectQuoteMessage } from './DirectQuoteMessage.js'

export let DirectQuote4Message = function ()
{
    DirectQuoteMessage.call(this, DirectMessageCode.CODE_QUOTE_4)
    this.Type = DirectQuoteMessage.QUOTE_OPTIONS

    this.Underlier = null
    this.Last = null
    this.Bid = Number.NaN
    this.Ask = Number.NaN
    this.BidSize = Number.NaN
    this.AskSize = Number.NaN
    this.PrevClose = null
    this.High = null
    this.Low = null
    this.LastSize = 0
    this.Volume = null
    this.Open = null
    this.OpenInterest = 0
}

DirectQuote4Message.prototype = Object.create(DirectQuoteMessage.prototype)

DirectQuote4Message.CreateFromQuote1 = function (q1m, option)
{
    var q4m = new DirectQuote4Message()

    if (!q1m || !option)
    {
        return q4m
    }

    q4m.Underlier = option.SourceName
    q4m.Route = q1m.Route

    q4m.Bid = q1m.Bid
    q4m.BidSize = q1m.BidSize

    q4m.Ask = q1m.Ask
    q4m.AskSize = q1m.AskSize

    q4m.Open = q1m.Open
    q4m.High = q1m.High
    q4m.Low = q1m.Low
    q4m.PrevClose = q1m.PrevClose

    q4m.Volume = q1m.TotalVolume
    q4m.Last = q1m.LastPice
    q4m.LastSize = q1m.LastSize
    q4m.OpenInterest = q1m.OpenInterest
    q4m.cTime = q1m.cTime

    q4m.PutCall = option.PutCall
    q4m.ExpYear = option.ExpDate.Year
    q4m.ExpMonth = option.ExpDate.Month
    q4m.ExpDay = option.ExpDate.Day
    q4m.StrikePrice = option.StrikePrice

    return q4m
}
